import axios from '@/lib/axios';
import { FlatRateLensOrderParams } from '../types';

const confirmFlatRateLens = (data: FlatRateLensOrderParams) => {
  return axios.post('/facility/orders/flat_rate_lens/confirm', data);
}

export default confirmFlatRateLens;